import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useOrgunitListData } from "./hooks/useOnBoard";
import { useState } from "react";

const OnboardingRequestDataColumns = (handleViewClick: (row: any) => void) => [
  {
    name: "Organisation Unit",
    selector: (row: { UnitName: string }) => row.UnitName || "-",
    sortable: true,
  },
  {
    name: "Action",
    width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];

const OnboardingRequest = () => {
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState({
    search: "",
  });

  const handleViewClick = (row: any) => {
    navigate(`/onboarding/requests/onboardingRequestByOrgUnit`, {
      state: { orgunitId: row },
    });
  };
  const { data: orgUnitsData, isLoading: orgUnitLoading } = useOrgunitListData({
    params: {
      search: filterData.search,
    },
    enable: true,
  });

  return (
    <div className="p-2 mb-5">
      <PageHeader
        title="Onboarding Requests List"
        buttons={[
          {
            label: "Import",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 4 clicked"),
            color: "#43B9B2",
          },
        ]}
      />
      <BasicDataTable
        Title="Org Unit"
        columns={OnboardingRequestDataColumns(handleViewClick)}
        data={orgUnitsData?.data /* formattedTableData */ || []}
        showSpinner={orgUnitLoading}
        pagination={false}
        handleSearch={(text: any) =>
          setFilterData((prev: any) => ({
            ...prev,
            search: text,
          }))
        }
      />
    </div>
  );
};

export default OnboardingRequest;
